import { Box } from "@mui/system";
import React from "react";
import { KeyboardArrowRightOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import {
  account,
  accountStatus,
  accountDetails,
  closeAccount,
} from "../messages";
import "../../assets/settings.scss";
import { useSession } from "../../hooks/useSession";
import CommonHeader from "../CommonHeader";
import {
  accountNameIcon,
  accountStatusIcon,
  closeAccountIcon,
} from "../images";
import Text from "../text/Text";
import CustomDivider from "../divider/Divider";

function AdvanceSettings(props) {
  const navigate = useNavigate();
  const { session } = useSession();

  const handleCloseAccount = () => {
    if (session?.account?.account?.closure_requested_at) {
      navigate("/settings/advance-settings/close-account/request-in-process");
    } else {
      navigate("/settings/advance-settings/close-account");
    }
  };
  const advanceSettingMenu = [
    {
      name: accountDetails,
      icon: (
        <img
          src={accountNameIcon}
          height={24}
          width={24}
          alt="account name icon"
        />
      ),
      action: () => navigate("/settings/advance-settings/change-account-name"),
    },
    {
      name: accountStatus,
      icon: (
        <img
          src={accountStatusIcon}
          height={24}
          width={24}
          alt="account status icon"
        />
      ),
      action: () => navigate("/settings/advance-settings/permission"),
    },
    {
      name: closeAccount,
      icon: (
        <img
          src={closeAccountIcon}
          height={24}
          width={24}
          alt="close account icon"
        />
      ),
      action: () => handleCloseAccount(),
    },
  ];

  return (
    <>
      <CommonHeader textAfterIcon={account} icon="backArrow" />
      <Box className="options-container">
        <Box className="settings-wrapper">
          <Box className="module-container">
            <Box className="settings-section">
              <Box className="setting-section-list">
                {advanceSettingMenu?.map((item, index) => (
                  <React.Fragment key={"menu_" + index}>
                    <Box
                      className="setting-section-conent"
                      onClick={item?.action || null}
                    >
                      <Box display="flex" alignItems="center">
                        <Box className="setting-section-icon">{item.icon}</Box>
                        <Text
                          className="default-text"
                          font="medium"
                          size={16}
                          sx={{ marginLeft: "16px" }}
                        >
                          {item.name}
                        </Text>
                      </Box>
                      <Box display="flex" alignItems="center">
                        {item?.text && (
                          <Text
                            className="default-text"
                            font="semibold"
                            size={16}
                            sx={{ marginRight: "8px" }}
                          >
                            {item.text}
                          </Text>
                        )}
                        <KeyboardArrowRightOutlined
                          sx={{
                            height: "24px",
                            width: "24px",
                            color: "#848B9E",
                          }}
                        />
                      </Box>
                    </Box>
                    {index < advanceSettingMenu.length - 1 && (
                      <CustomDivider
                        sx={{
                          margin: "0px 14px 0px 50px",
                          borderColor: "#f0f0f0",
                        }}
                      />
                    )}
                  </React.Fragment>
                ))}
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default AdvanceSettings;
